import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Frame } from './frame.component';
import { NavigationModule } from '../navigation/navigation.module';
import { LayoutModule } from '@angular/cdk/layout';

@NgModule({
  declarations: [
    Frame,
  ],
  exports: [
    Frame,
  ],
  imports: [
    CommonModule,
    LayoutModule,
    NavigationModule,
  ]
})
class FrameModule { }

export {
  FrameModule,
  Frame
};
